import { gql } from "@apollo/client";
export const UploadTransactionCSV = gql `
  mutation UploadTransactionCSV(
    $input: UploadTransactionCSVInput!
    $upload: Upload!
  ) {
    UploadTransactionCSV(input: $input, upload: $upload)
  }
`;
